import axios from "axios";
import { resetStore, setSimulatedUser, setSimulatedAgent } from './config.actions';

export const SET_LOADING = "SET_LOADING";
export const SIGN_OUT = "SIGN_OUT";
export const SIGN_OUT_AGENT = "SIGN_OUT_AGENT";
export const UPDATE_USER = "UPDATE_USER";
export const SET_USER = "SET_USER";
export const SET_AGENT = "SET_AGENT";
//export const SET_GUEST_INFLUENCER = "SET_GUEST_INFLUENCER";

export const setUser = (user) => ({ type: SET_USER, payload: user });
export const setAgent = (agent) => ({ type: SET_AGENT, payload: agent });
export const setGlobalLoading = (loading = false) => ({ type: SET_LOADING, payload: loading });

export const signOut = (dispatch) => {
  axios.defaults.headers.common.Authorization = null;
  localStorage.removeItem("user");
  localStorage.removeItem("simulatedUser");
  dispatch(setSimulatedUser(null));
  return dispatch({ type: SIGN_OUT });
};

export const signOutAgent = (dispatch) => {
  axios.defaults.headers.common.Authorization = null;
  localStorage.removeItem("agent");
  localStorage.removeItem("simulatedAgent");
  dispatch(setSimulatedAgent(null));
  sessionStorage.clear();
  dispatch(resetStore());
  return dispatch({ type: SIGN_OUT_AGENT });
};

export const updateUser = (user) => ({
  type: UPDATE_USER,
  payload: user,
});

//export const setGuestInfluencer = (guestInfluencer) => ({
//  type: SET_GUEST_INFLUENCER,
//  payload: guestInfluencer,
//});
